const MyTeamStyles = {
	select: { height: '30px', width: '200px', },
	noDataContainer: { width: '100%', height: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' },
	subtitle1: { color: 'grey', fontSize: '12px' },
	name: { fontSize: '14px' },
	gridContainer: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingLeft: '5px', paddingRight: '5px', border: '1px solid #D8D5FF', borderRadius: '10px', marginBottom: '10px' },
} as const;

export default MyTeamStyles;

